import { ethers} from "ethers";
export const networks = [369];

export const ChainId = {
  MAINNET: 369,
};

export const routerAddress = new Map();
routerAddress.set(ChainId.MAINNET, "0xA88293f625eDD66b4E98C4368D532f47634eCA7D");

export const primaryProvider = new ethers.providers.JsonRpcProvider("https://rpc-pulsechain.g4mm4.io");
export const backupProvider = new ethers.providers.JsonRpcProvider("https://rpc.pulsechain.com");
